import { FC, CSSProperties, ReactNode } from 'react'
import { noop } from 'lodash'
import Link from './Link'

type LinkButtonProps = {
  href: string
  className?: string
  style?: CSSProperties
  onClick?: () => void
  children?: ReactNode
}

const LinkButton: FC<LinkButtonProps> = ({ href, className = 'btn', style, onClick = noop, children }) => {
  return (
    <Link className={className} href={href} onClick={onClick} style={style}>
      <span>{children}</span>
    </Link>
  )
}

export default LinkButton
